import * as PIXI from "pixi.js"
import { Idea, ideaHeight, ideaWidth } from "../model/types"
import { grid_to_plane } from "./coords"
import { BOX_WIDTH } from "./grid"
import { drawHighlightEdgeTo } from "./renderers"

type PlaneOffset = {
  dpx: number
  dpy: number
}

type SelectionOrigin = {
  gx1: number
  gy1: number
}

export default class SelectionRenderer {
  private selection_layer: PIXI.Graphics

  constructor(selection_layer: PIXI.Graphics) {
    this.selection_layer = selection_layer
  }

  render_selection(
    selected_ideas: Idea[],
    re_render: boolean,
    { dpx, dpy }: PlaneOffset = { dpx: 0, dpy: 0 },
  ): void {
    const { gx1, gy1 } = selected_ideas.reduce<SelectionOrigin>(
      ({ gx1, gy1 }, { location: { gx, gy } }) => {
        return {
          gx1: Math.min(gx1, gx),
          gy1: Math.min(gy1, gy),
        }
      },
      { gx1: 1000, gy1: 1000 },
    )

    if (re_render) {
      this.selection_layer.clear()
      const selected_idea_locations = selected_ideas.reduce((acc, idea) => {
        acc.add(`${idea.location.gx}x${idea.location.gy}`)
        return acc
      }, new Set<string>())

      selected_ideas.forEach((idea) => {
        const {
          location: { gx, gy },
        } = idea
        const width = ideaWidth(idea)
        const height = ideaHeight(idea)
        const xi = gx - gx1
        const yi = gy - gy1
        this.selection_layer.lineStyle(0)
        this.selection_layer.beginFill(0xff0044, 0.5)
        this.selection_layer.drawRect(
          xi * BOX_WIDTH,
          yi * BOX_WIDTH,
          width * BOX_WIDTH,
          height * BOX_WIDTH,
        )
        this.selection_layer.endFill()

        // top and bottom side
        for (let i = 0; i < width; i++) {
          if (!selected_idea_locations.has(`${gx + i}x${gy - 1}`))
            drawHighlightEdgeTo(this.selection_layer, "top", xi + i, yi, 1, height, 0x771111)
          if (!selected_idea_locations.has(`${gx + i}x${gy + 1}`))
            drawHighlightEdgeTo(this.selection_layer, "bottom", xi + i, yi, 1, height, 0x771111)
        }
        // left and right side
        for (let i = 0; i < height; i++) {
          if (!selected_idea_locations.has(`${gx - 1}x${gy + i}`))
            drawHighlightEdgeTo(this.selection_layer, "left", xi, yi + i, width, 1, 0x771111)
          if (!selected_idea_locations.has(`${gx + 1}x${gy + i}`))
            drawHighlightEdgeTo(this.selection_layer, "right", xi, yi + i, width, 1, 0x771111)
        }
      })
    }

    const { px, py } = grid_to_plane({
      gx: gx1,
      gy: gy1,
    })
    this.selection_layer.x = px + dpx
    this.selection_layer.y = py + dpy
    this.selection_layer.renderable = true
  }
}
